import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import pages from './routes/pages'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  base: window.__env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...pages,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  const isUserLogged = isLoggedIn && isLoggedIn.length > 0;
  const userData = isUserLogged ? getUserData() : null;
  
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login', query: to.query })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  if (isUserLogged && to.path === "/reset-password") {
    if (userData && userData.profile.tag === "/reset-password") {
      return next({name: "/reset-password"});
    }
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

router.afterEach((to, from) => {

  // Clear some app states when route changes
  changeChatbotPosition(to)
  store.dispatch("user/clear");

})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.classList.add('loading-hidden')
  }
})

const changeChatbotPosition = (to)=> {
  if(to.name === 'home') {
    store.commit("chatbot/setViewHasSidenav", false);
    return;
  }
  store.commit("chatbot/setViewHasSidenav", true);
}

export default router
